/**
 * Decode an ExoClick-style passed email parameter (`epb` -- "email passing
 * base encoded"). ExoClick's PFB feature passes the visitor's email as a
 * base64-encoded string in the URL (e.g. `&pfb[email]=...`), which we expose
 * here as `?epb=...` so it stays decoupled from any single ad network.
 *
 * Returns the decoded email if it looks like a valid email, otherwise undefined.
 */
export const decodeEpbEmail = (encoded: string | null | undefined): string | undefined => {
    if (!encoded) return undefined;
    try {
        // Support URL-safe base64 (some networks pass `-`/`_` instead of `+`/`/`)
        const normalized = encoded.replace(/-/g, '+').replace(/_/g, '/');
        const padded = normalized + '='.repeat((4 - (normalized.length % 4)) % 4);
        const decoded = atob(padded);
        return decoded.includes('@') ? decoded : undefined;
    } catch {
        return undefined;
    }
};
